(function () {
    const gmCloseButtons = document.querySelectorAll('.close-popup');
    gmCloseButtons.forEach((el) =>
        el.addEventListener('click', (event) => {
            el.closest('.popup').classList.remove('popup--visible');
        })
    );

    function gmOn(eventType, selector, callback) {
        document
            .querySelector('.main-content')
            .addEventListener(eventType, function (event) {
                if (event.target.matches(selector)) {
                    callback.call(event.target);
                } else {
                    var sortingEl = document.querySelector(
                        '.product-sorting__list'
                    );

                    if (sortingEl !== null) {
                        sortingEl.classList.remove(
                            'product-sorting__list--expanded'
                        );
                    }
                }
            });
    }
    if (
        document.querySelector('#search-result') &&
        document.querySelector('.product-sorting__list')
    )
        gmOn('click', '.product-sorting__list-item', function () {
            if (this.classList.contains('product-sorting__list-item--active'))
                this.closest('.product-sorting__list').classList.toggle(
                    'product-sorting__list--open'
                );
            else window.location = this.dataset.value;
        });

    if (
        document.querySelector('.sub-categories--slider') &&
        document.querySelector('.sub-categories__items')
    ) {
        const slider = tns({
            container: '.sub-categories--slider .sub-categories__items',
            autoWidth: true,
            loop: false,
            mouseDrag: true,
            prevButton: '.sub-categories__prev',
            nextButton: '.sub-categories__next',
            swipeAngle: false,
            speed: 400,
            nav: false,
        });
    }
    if (document.querySelector('#load-more-button')) {
        if (
            localStorage.getItem('lazyInfo') &&
            window.history.state == 'search'
        ) {
            window.history.scrollRestoration = 'manual';
        } else {
            window.history.scrollRestoration = 'auto';
        }
    }

    //language select

    const languageSelect = document.querySelector('#countrylinks > a');

    if (languageSelect) {
        languageSelect.addEventListener('click', (elem) => {
            const languageList = elem.target.closest('div').querySelector('ul');
            if (languageList) {
                languageList.classList.toggle('market__list--show');
            }
        });
    }
    function onClickOutside(ele, cb) {
        document.addEventListener('click', (event) => {
            if (!ele.contains(event.target)) cb();
        });
    }

    const languageBox = document.querySelector('#countrylinks');
    if (languageBox) {
        onClickOutside(languageBox, () => {
            const languageList = languageBox.querySelector(
                '.market__list--show'
            );
            if (languageList) {
                languageList.classList.remove('market__list--show');
            }
        });
    }

    //category readmore
    const readMoreButton = document.querySelector(
        '.category__extra-content-button'
    );
    if (readMoreButton) {
        readMoreButton.addEventListener('click', (e) => {
            const parent = e.target.parentNode;
            parent.classList.toggle('category__extra-content--show');
            const text = e.target.dataset.text;
            const currentText = e.target.innerText;
            e.target.dataset.text = currentText;
            e.target.innerText = text;
        });
    }

    //smoth scroll to anchor id
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const header = document.querySelector('.header__main');
            let offSet = 0;
            if (window.innerWidth > 767) {
                if (header && header.classList.contains('sticky-nav')) {
                    offSet = 70;
                } else {
                    offSet = 90;
                }
            }
            const topOfElement =
                document.querySelector(this.getAttribute('href')).offsetTop -
                offSet;
            window.scroll({ top: topOfElement, behavior: 'smooth' });
        });
    });

    //product images
    const allImages = document.querySelectorAll('.product-detail__image');
    function imgLoaded(el) {
        el.parentNode.classList.remove('loading-image');
    }
    if (allImages) {
        allImages.forEach((x) => {
            if (x.complete) {
                imgLoaded(x);
            } else {
                x.addEventListener('load', imgLoaded(x, 'onload'));
            }
        });
    }

    //video hero. Should remove this and use video-source media-queries instead.
    const videos = document.querySelectorAll('.hero__video-player');
    if (videos) {
        videos.forEach((video) => {
            const source = video.querySelector('source');
            if (source) {
                source.setAttribute(
                    'src',
                    window.innerWidth > 767
                        ? source.dataset.src
                        : source.dataset.mobileSrc
                );
                source.setAttribute(
                    'type',
                    window.innerWidth > 767
                        ? source.dataset.type
                        : source.dataset.mobileType
                );
                video.load();
            }
        });
    }
    window.LoadCategoryPageLayout = () => {
        //category page list layout
        const items = document.querySelectorAll(
            '.product-list-category .product-list__item'
        );
        let listWrapper;
        const setProductList = () => {
            let banners = [],
                col = 2;
            if (listWrapper.classList.contains('product-list--four-col')) {
                col = 4;
            }
            let c = 0;
            for (let key of items) {
                if (!key.classList.contains('product-list__item-banner')) {
                    c++;
                } else {
                    banners.push(key);
                }
                if (banners.length > 0 && c % col == 0) {
                    banners.forEach((b, i) => {
                        if (i == 0) key.insertAdjacentElement('afterend', b);
                        else
                            banners[i - 1].insertAdjacentElement('afterend', b);
                    });
                    banners = [];
                }
            }
        };
        if (items.length > 0 && window.innerWidth <= 767) {
            listWrapper = items[0].parentNode.parentNode;
            if (localStorage.getItem('list-layout')) {
                listWrapper.classList.forEach((x) => {
                    if (x.startsWith('product-list--')) {
                        listWrapper.classList.remove(x);
                    }
                });
                listWrapper.classList.add(localStorage.getItem('list-layout'));
                const selected = document.querySelector(
                    '[data-class="' + localStorage.getItem('list-layout') + '"]'
                );
                if (selected) {
                    selected.classList.add('selected');
                }
            } else {
                document
                    .querySelector('.layout-select__two-col')
                    .classList.add('selected');
            }
            if (!listWrapper.classList.contains('product-list--one-col')) {
                setProductList();
            }
            const select = document.querySelectorAll('.layout-select > div');
            if (select.length > 0) {
                select.forEach((s) => {
                    s.addEventListener('click', function (e) {
                        listWrapper.classList.forEach((x) => {
                            if (x.startsWith('product-list--')) {
                                listWrapper.classList.remove(x);
                            }
                        });
                        if (
                            e.currentTarget.parentNode.querySelector(
                                '.selected'
                            )
                        ) {
                            e.currentTarget.parentNode
                                .querySelector('.selected')
                                .classList.remove('selected');
                        }
                        e.currentTarget.classList.add('selected');
                        listWrapper.classList.add(
                            e.currentTarget.dataset.class
                        );
                        setProductList();
                        localStorage.setItem(
                            'list-layout',
                            e.currentTarget.dataset.class
                        );
                    });
                });
            }
        }
    };
    LoadCategoryPageLayout();
})();
